import { OutlinedSelect, OutlinedSelectOptionType } from '@octano/global-ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../locales/translations';
import { usePerformanceAnalysisFiltersLoaderQuery } from './PerformanceAnalysisFiltersLoader';
import { usePerformanceAnalysisPeriodLoader } from './PerformanceAnalysisPeriodLoader';

export function PerformanceAnalysisPeriod() {
  const data = usePerformanceAnalysisPeriodLoader();
  const { query, updateQuery } = usePerformanceAnalysisFiltersLoaderQuery();
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );
  const onChange = useCallback(
    (value?: OutlinedSelectOptionType | null) => {
      if (!value) {
        return;
      }
      updateQuery({
        periodId: value.value as number,
      });
    },
    [updateQuery],
  );

  const options = useMemo(() => {
    return data.periods.map((p) => ({
      value: p.id,
      label: p.name,
    }));
  }, [data.periods]);

  return (
    <Row>
      <Col xs={12} md={4}>
        <OutlinedSelect
          value={options.find((o) => o.value === query.periodId)}
          onChange={onChange}
          name="period"
          label={t('filters.period')}
          placeholder={t('filters.periodPlaceholder')}
          options={options}
          isClearable={false}
        />
      </Col>
    </Row>
  );
}
